import { FONT_FACE_DAGNY_DISPLAY, FONT_FACE_DAGNY_TEXT, FONT_FACE_NITTI_GROTESK_NN_HEADING, FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR, FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM, FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD, FONT_FACE_CALIBRI, FONT_FACE_ARIAL, } from '@nn-design-system/fonts/dist/constants';
/**
 * Variants
 */
export const VARIANT_DEFAULT = 'Default';
// Legacy
export const VARIANT_LEGACY = 'Legacy';
// Importance
export const VARIANT_ATTENTIONAL = 'Attentional';
export const VARIANT_ATTENTIONAL_MEDIUM = 'AttentionalMedium';
export const VARIANT_ATTENTIONAL_XXL = 'AttentionalXXL';
export const VARIANT_ATTENTIONAL_XXL_CENTERED = 'AttentionalXXLCentered';
export const VARIANT_ATTENTIONAL_XL = 'AttentionalXL';
export const VARIANT_ATTENTIONAL_XL_CENTERED = 'AttentionalXLCentered';
export const VARIANT_ATTENTIONAL_UNORDERED = 'AttentionalUnordered';
export const VARIANT_ATTENTIONAL_ORDERED = 'AttentionalOrdered';
export const VARIANT_TINTED = 'Tinted';
export const VARIANT_PRIMARY = 'Primary';
export const VARIANT_PRIMARY_STRONG = 'PrimaryStrong';
export const VARIANT_PRIMARY_STAND_ALONE = 'PrimaryStandAlone';
export const VARIANT_PRIMARY_STAND_ALONE_STRONG = 'PrimaryStandAloneStrong';
export const VARIANT_PRIMARY_LARGE = 'PrimaryLarge';
export const VARIANT_PRIMARY_MEDIUM = 'PrimaryMedium';
export const VARIANT_PRIMARY_SMALL = 'PrimarySmall';
export const VARIANT_PLAIN_LARGE = 'PlainLarge';
export const VARIANT_PLAIN_MEDIUM = 'PlainMedium';
export const VARIANT_PLAIN_SMALL = 'PlainSmall';
export const VARIANT_SECONDARY = 'Secondary';
export const VARIANT_SECONDARY_STRONG = 'SecondaryStrong';
export const VARIANT_SECONDARY_STAND_ALONE = 'SecondaryStandAlone';
export const VARIANT_SECONDARY_STAND_ALONE_STRONG = 'SecondaryStandAloneStrong';
export const VARIANT_ADD = 'Add';
export const VARIANT_SMALL_STRONG = 'SmallStrong';
export const VARIANT_SMALL_SUBTLE = 'SmallSubtle';
export const VARIANT_STRONG = 'Strong';
export const VARIANT_SUB_LABEL = 'SubLabel';
export const VARIANT_TERM = 'Term';
export const VARIANT_INFO = 'Info';
// Sizes
export const VARIANT_XS = 'XS';
export const VARIANT_XS_CENTERED = 'XSCentered';
export const VARIANT_SMALL = 'Small';
export const VARIANT_SMALL_CENTERED = 'SmallCentered';
export const VARIANT_SMALL_INVERTED = 'SmallInverted';
export const VARIANT_MEDIUM = 'Medium';
export const VARIANT_MEDIUM_CENTERED = 'MediumCentered';
export const VARIANT_MEDIUM_INVERTED = 'MediumInverted';
export const VARIANT_LARGE = 'Large';
export const VARIANT_LARGE_CENTERED = 'LargeCentered';
export const VARIANT_LARGE_INVERTED = 'LargeInverted';
export const VARIANT_XL = 'XL';
export const VARIANT_XL_CENTERED = 'XLCentered';
export const VARIANT_XXL = 'XXL';
export const VARIANT_XXL_CENTERED = 'XXLCentered';
export const VARIANT_COMPACT = 'Compact';
export const VARIANT_LANDSCAPE = 'Landscape';
export const VARIANT_SQUARE = 'Square';
// Direction
export const VARIANT_VERTICAL_MEDIUM = 'VerticalMedium';
export const VARIANT_VERTICAL_LARGE = 'VerticalLarge';
export const VARIANT_VERTICAL_XXL = 'VerticalXXL';
export const VARIANT_VERTICAL = 'Vertical';
export const VARIANT_HORIZONTAL = 'Horizontal';
export const VARIANT_HORIZONTAL_FULL_WIDTH = 'HorizontalFullWidth';
export const VARIANT_RIGHT_ALIGNED = 'RightAligned';
// Actions / permission
export const VARIANT_WITH_SHOW_ACTION = 'WithShowAction';
export const VARIANT_WITH_EDIT_ACTION = 'WithEditAction';
export const VARIANT_WITH_ADD_ACTION = 'WithAddAction';
export const VARIANT_WITH_SHOW_EXTERNAL_ACTION = 'WithShowExternalAction';
export const VARIANT_WITH_DOWNLOAD_ACTION = 'WithDownloadAction';
export const VARIANT_SELECTABLE = 'Selectable';
export const VARIANT_MULTIPLE_SELECTABLE = 'MultipleSelectable';
export const VARIANT_DISMISSIBLE = 'Dismissible';
// Feedback
export const VARIANT_ERROR = 'Error';
export const VARIANT_INFORMATIVE = 'Informative';
export const VARIANT_SUCCESS = 'Success';
export const VARIANT_WARNING = 'Warning';
export const VARIANT_WITH_COUNT = 'WithCount';
export const VARIANT_NO_INTERNET_CONNECTION_WHILE_REQUESTING_DATA = 'NoInternetConnectionWhileRequestingData';
export const VARIANT_NO_INTERNET_CONNECTION_WHILE_SENDING_DATA = 'NoInternetConnectionWhileSendingData';
export const VARIANT_ERROR_WHILE_REQUESTING_DATA = 'ErrorWhileRequestingData';
export const VARIANT_ERROR_WHILE_SENDING_DATA = 'ErrorWhileSendingData';
// Dividers
export const VARIANT_DIVIDERS_BETWEEN = 'DividersBetween';
export const VARIANT_DIVIDERS_BETWEEN_AND_START = 'DividersBetweenAndStart';
export const VARIANT_DIVIDERS_BETWEEN_AND_END = 'DividersBetweenAndEnd';
export const VARIANT_DIVIDERS_BETWEEN_START_AND_END = 'DividersBetweenStartAndEnd';
// Misc.
export const VARIANT_WITH_ADDITIONAL_ACTION = 'WithAdditionalAction';
export const VARIANT_NON_INTERACTIVE_DOTS = 'NonInteractiveDots';
export const VARIANT_DEFAULT_RELATIVE = 'DefaultRelative';
export const VARIANT_COMPACT_RELATIVE = 'CompactRelative';
export const VARIANT_UNORDERED = 'Unordered';
export const VARIANT_ACHIEVED_MEDIUM = 'AchievedMedium';
export const VARIANT_FORM = 'Form';
export const VARIANT_FORM_SECONDARY = 'FormSecondary';
export const VARIANT_LIST_ITEM = 'ListItem';
export const VARIANT_ATTENTIONAL_LIST_ITEM = 'AttentionalListItem';
export const VARIANT_XS_ATTENTIONAL = 'XSAttentional';
export const VARIANT_SMALL_ATTENTIONAL = 'SmallAttentional';
export const VARIANT_PROGRESS_INDICATOR_CATEGORY = 'ProgressIndicatorCategory';
export const VARIANT_NO_LIST_STYLE_TYPE = 'NoListStyleType';
export const VARIANT_CHARACTER = 'Character';
export const VARIANT_MULTILINE = 'Multiline';
export const VARIANT_WITH_BOTTOM_SHEET = 'WithBottomSheet';
export const VARIANT_NATIVE = 'Native';
export const VARIANT_WITH_NATIVE_DATEPICKER = 'WithNativeDatepicker';
export const VARIANT_WITH_NATIVE_MENU = 'WithNativeMenu';
export const VARIANT_WITH_ICON = 'WithIcon';
export const VARIANT_WITH_LINK = 'WithLink';
/**
 * Elements
 */
// Icons
export const ELEMENT_ICON = 'Icon';
export const ELEMENT_SHOW_ICON = 'ShowIcon';
export const ELEMENT_EDIT_ICON = 'EditIcon';
export const ELEMENT_ADD_ICON = 'AddIcon';
export const ELEMENT_SHOW_EXTERNAL_ICON = 'ShowExternalIcon';
export const ELEMENT_DOWNLOAD_ICON = 'DownloadIcon';
export const ELEMENT_SELECTED_ICON = 'SelectedIcon';
export const ELEMENT_OPEN_ICON = 'OpenIcon';
export const ELEMENT_CLEAR_ICON = 'ClearIcon';
export const ELEMENT_SEARCH_ICON = 'SearchIcon';
// Badges
export const ELEMENT_GRAY_BADGE = 'GrayBadge';
export const ELEMENT_GRAY_BADGE_ICON = 'GrayBadgeIcon';
export const ELEMENT_SAND_BADGE = 'SandBadge';
export const ELEMENT_SAND_BADGE_ICON = 'SandBadgeIcon';
export const ELEMENT_PURPLE_BADGE = 'PurpleBadge';
export const ELEMENT_PURPLE_BADGE_ICON = 'PurpleBadgeIcon';
export const ELEMENT_GREEN_BADGE = 'GreenBadge';
export const ELEMENT_GREEN_BADGE_ICON = 'GreenBadgeIcon';
export const ELEMENT_BLUE_BADGE = 'BlueBadge';
export const ELEMENT_BLUE_BADGE_ICON = 'BlueBadgeIcon';
export const ELEMENT_DARK_ORANGE_BADGE = 'DarkOrangeBadge';
export const ELEMENT_DARK_ORANGE_BADGE_ICON = 'DarkOrangeBadgeIcon';
export const ELEMENT_LIGHT_ORANGE_BADGE = 'LightOrangeBadge';
export const ELEMENT_LIGHT_ORANGE_BADGE_ICON = 'LightOrangeBadgeIcon';
// Buttons
export const ELEMENT_BUTTON = 'Button';
export const ELEMENT_BACK_BUTTON = 'BackButton';
export const ELEMENT_CLOSE_BUTTON = 'CloseButton';
export const ELEMENT_ADD_BUTTON = 'AddButton';
export const ELEMENT_DELETE_BUTTON = 'DeleteButton';
export const ELEMENT_SLIDE_BUTTON = 'SlideButton';
export const ELEMENT_OPEN_DATEPICKER_BUTTON = 'OpenDatepickerButton';
export const ELEMENT_PREVIOUS_BUTTON = 'PreviousButton';
export const ELEMENT_NEXT_BUTTON = 'NextButton';
export const ELEMENT_UPLOAD_BUTTON = 'UploadButton';
export const ELEMENT_CANCEL_BUTTON = 'CancelButton';
export const ELEMENT_SWITCH_VIEW_BUTTON = 'SwitchViewButton';
export const ELEMENT_DISMISS_BUTTON = 'DismissButton';
export const ELEMENT_LINK = 'Link';
// Actions
export const ELEMENT_ACTION = 'Action';
export const ELEMENT_ACTION_ITEM = 'ActionItem';
export const ELEMENT_PRIMARY_ACTION = 'PrimaryAction';
export const ELEMENT_SECONDARY_ACTION = 'SecondaryAction';
export const ELEMENT_OPEN_TRIGGER = 'OpenTrigger';
// Typography
export const ELEMENT_HEADING = 'Heading';
export const ELEMENT_PARAGRAPH = 'Paragraph';
export const ELEMENT_BODY_TEXT = 'BodyText';
export const ELEMENT_SUBTEXT = 'Subtext';
export const ELEMENT_GROUP_LABEL = 'GroupLabel';
export const ELEMENT_LABEL = 'Label';
export const ELEMENT_PLACEHOLDER = 'Placeholder';
export const ELEMENT_INLINE_MESSAGE = 'InlineMessage';
export const ELEMENT_DROP_ZONE_MESSAGE = 'DropZoneMessage';
export const ELEMENT_DESCRIPTION = 'Description';
export const ELEMENT_TITLE = 'Title';
export const ELEMENT_TEXT = 'Text';
export const ELEMENT_LEGEND = 'Legend';
export const ELEMENT_CATEGORY = 'Category';
export const ELEMENT_FACTUAL = 'Factual';
export const ELEMENT_FACTUAL_VERB = 'FactualVerb';
export const ELEMENT_EXPECTED = 'Expected';
export const ELEMENT_SELECTION = 'Selection';
export const ELEMENT_TERM = 'Term';
export const ELEMENT_VALUE = 'Value';
export const ELEMENT_SELECTED_VALUE = 'SelectedValue';
export const ELEMENT_ACCOUNT = 'Account';
export const ELEMENT_MENU_HEADING = 'MenuHeading';
export const ELEMENT_DATE = 'Date';
export const ELEMENT_WEEKDAY = 'Weekday';
// Numbers
export const ELEMENT_AMOUNT = 'Amount';
export const ELEMENT_SIGN = 'Sign';
export const ELEMENT_CURRENCY_SYMBOL = 'CurrencySymbol';
export const ELEMENT_INTEGERS = 'Integers';
export const ELEMENT_DECIMALS = 'Decimals';
export const ELEMENT_TOTAL_COUNT = 'TotalCount';
export const ELEMENT_VISIBLE_RESULT_RANGE = 'VisibleResultRange';
// Form
export const ELEMENT_KNOB = 'Knob';
export const ELEMENT_CHECKBOX = 'Checkbox';
export const ELEMENT_RADIO = 'Radio';
export const ELEMENT_INPUT = 'Input'; // Input including placeholder
export const ELEMENT_FIELDSET = 'Fieldset';
export const ELEMENT_CODE_FIELD = 'CodeField';
export const ELEMENT_DATEPICKER = 'Datepicker';
// Containers
export const ELEMENT_CONTAINER = 'Container';
export const ELEMENT_CONTENT_CONTAINER = 'ContentContainer';
export const ELEMENT_INPUT_CONTAINER = 'InputContainer';
export const ELEMENT_BAR_CONTAINER = 'BarContainer';
export const ELEMENT_MODAL = 'Modal';
// Misc.
export const ELEMENT_LOGO = 'Logo';
export const ELEMENT_CARD = 'Card';
export const ELEMENT_IMAGE = 'Image';
export const ELEMENT_BAR = 'Bar';
export const ELEMENT_BACKDROP = 'Backdrop';
export const ELEMENT_ITEM = 'Item';
export const ELEMENT_PAGINATION = 'Pagination';
export const ELEMENT_BOX = 'Box';
export const ELEMENT_MASK_SYMBOL = 'MaskSymbol';
export const ELEMENT_CURSOR_SYMBOL = 'CursorSymbol';
export const ELEMENT_CIRCLE = 'Circle';
export const ELEMENT_DIVIDER = 'Divider';
export const ELEMENT_TRACK = 'Track';
export const ELEMENT_INDICATOR = 'Indicator';
export const ELEMENT_INDICATOR_ICON = 'IndicatorIcon';
export const ELEMENT_EXCEEDED_INDICATOR = 'ExceededIndicator';
export const ELEMENT_INDICATORS_DIVIDER = 'IndicatorsDivider';
export const ELEMENT_LIST = 'List';
export const ELEMENT_LIST_ITEM = 'ListItem';
export const ELEMENT_MARKER = 'Marker';
export const ELEMENT_SPINNER_LOADER = 'SpinnerLoader';
export const ELEMENT_MENU = 'Menu';
export const ELEMENT_MENU_ITEM = 'MenuItem';
export const ELEMENT_COLLAPSIBLE_SECTION_TRIGGER = 'CollapsibleSectionTrigger';
export const ELEMENT_COLLAPSIBLE_SECTION = 'CollapsibleSection';
export const ELEMENT_TAB = 'Tab';
export const ELEMENT_TAB_INDICATOR = 'TabIndicator';
export const ELEMENT_STEP_INDICATOR_STEP = 'StepIndicatorStep';
export const ELEMENT_STEP_CONNECTOR_LINE = 'StepConnectorLine';
export const ELEMENT_PIPELINE_STEP = 'PipelineStep';
export const ELEMENT_PIPELINE_STEP_TRIGGER = 'PipelineStepTrigger';
export const ELEMENT_TABLE = 'Table';
export const ELEMENT_TABLE_HEADER = 'TableHeader';
export const ELEMENT_TABLE_HEADER_CELL = 'TableHeaderCell';
export const ELEMENT_TABLE_CELL = 'TableCell';
export const ELEMENT_TABLE_TOOLBAR = 'TableToolbar';
export const ELEMENT_TABLE_SELECTION_COUNT = 'TableSelectionCount';
export const ELEMENT_PAGINATION_ITEMS_COUNT = 'PaginationItemsCount';
export const ELEMENT_PAGINATION_PAGE = 'PaginationPage';
/**
 * Interaction states
 */
// Buttons
export const INTERACTION_STATE_ACTIVE = 'Active';
export const INTERACTION_STATE_HOVER = 'Hover';
// Form
export const INTERACTION_STATE_FOCUS_VISIBLE = 'FocusVisible';
export const INTERACTION_STATE_DATEPICKER_OPEN = 'DatepickerOpen';
// Scroll
export const INTERACTION_STATE_SCROLLING = 'Scrolling';
export const INTERACTION_STATE_AT_BOTTOM = 'AtBottom';
// Swipe
export const INTERACTION_STATE_SWIPE = 'Swipe';
// Open
export const INTERACTION_STATE_OPEN = 'Open';
export const INTERACTION_STATE_EXPANDED = 'Expanded';
export const INTERACTION_STATE_VISIBLE = 'Visible';
/**
 * Data states
 */
// Form
export const DATA_STATE_VALID = 'Valid';
export const DATA_STATE_INVALID = 'Invalid';
export const DATA_STATE_ON = 'On';
export const DATA_STATE_SELECTED = 'Selected';
export const DATA_STATE_CHECKED = 'Checked';
export const DATA_STATE_INDETERMINATE = 'Indeterminate';
export const DATA_STATE_DISABLED = 'Disabled';
export const DATA_STATE_UNAVAILABLE = 'Unavailable';
export const DATA_STATE_IS_TODAY = 'IsToday';
export const DATA_STATE_TODAY_SELECTED = 'TodaySelected';
export const DATA_STATE_READ_ONLY = 'ReadOnly';
// Pagination
export const DATA_STATE_ACTIVE = 'Active';
// Progress
export const DATA_STATE_EXCEEDING = 'Exceeding';
export const DATA_STATE_EXCEEDED_POSITIVE = 'ExceededPositive';
export const DATA_STATE_EXCEEDED_NEGATIVE = 'ExceededNegative';
export const DATA_STATE_ACHIEVED = 'Achieved';
// Step
export const DATA_STATE_CURRENT = 'Current';
export const DATA_STATE_COMPLETED = 'Completed';
export const DATA_STATE_CANCELLED = 'Cancelled';
// Range
export const DATA_STATE_MINIMUM_REACHED = 'MinimumReached';
export const DATA_STATE_MAXIMUM_REACHED = 'MaximumReached';
export const DATA_STATE_IS_IN_DATE_RANGE = 'IsInDateRange';
/**
 * Font faces
 */
export { FONT_FACE_DAGNY_DISPLAY, FONT_FACE_DAGNY_TEXT, FONT_FACE_NITTI_GROTESK_NN_HEADING, FONT_FACE_NITTI_GROTESK_NN_TEXT_REGULAR, FONT_FACE_NITTI_GROTESK_NN_TEXT_MEDIUM, FONT_FACE_NITTI_GROTESK_NN_TEXT_BOLD, FONT_FACE_CALIBRI, FONT_FACE_ARIAL, };
